const BaseView = require('components-framework/view/base.view');
const fieldUtils = require('od-modules/utils/field.utils');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const withRenderedMain = require('components-framework/view/with_rendered_main');

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    selectors: {
        setupPasswordContainer: '.setup_password_container',
        setupPasswordTextContainer: '.setup_password_text_container',
        setupPasswordFormContainer: '.setup_password_form_container',
        loadingSpinnerContainer: '.loading_spinner_container',

        form: '.setup_password_form',
        passwordInput: '.password',
        confirmPasswordInput: '.confirm_password',
        prismaInput: '.prisma_input_group',
    },
    events: {
        'input input[name="password"]': 'onPasswordChanged',
        'input input[name="confirmPassword"]': 'onConfirmPasswordChanged',

        'focusin input[name="password"], input[name="confirmPassword"]': 'onInputFocus',
        'focusout input[name="password"]': 'onValidateInput',
        'focusout input[name="confirmPassword"]': 'onValidateConfirmPasswordInput',
        'blur .prisma_input_group': 'onBlurInput',
        'tap .search_with_prime_button': 'onTapSearchWithPrime',
    },

    constants: {
        validState: 'valid',
        invalidState: 'invalid',
        emptyState: 'empty',
        defaultState: 'default',
        initState: 'init',
        mismatchState: 'mismatch',
        minLength: 7,
    },

    initialize(options) {
        BaseView.prototype.initialize.call(this, options);
    },

    renderSetupPassword(data) {
        const {email, hashCode} = data;
        this.model.setHashCode(hashCode);
        this.keys.description = Odigeo.Utils.replaceCmsKeyArgs(this.keys.description, email);

        this.$cachedSelectors.setupPasswordContainer.append($(this.templates.setupPassword({
            title: this.keys.title,
            description: this.keys.description,
            passwordLabel: this.keys.passwordLabel,
            passwordPlaceholder: this.keys.passwordPlaceholder,
            errorMandatoryPassword: this.keys.errorMandatoryPassword,
            errorInvalidPassword: this.keys.errorInvalidPassword,
            reenterPassword: this.keys.reenterPassword,
            confirmPassword: this.keys.confirmPassword,
            errorMandatoryConfirmPassword: this.keys.errorMandatoryConfirmPassword,
            errorPasswordMismatch: this.keys.errorPasswordMismatch,
            errorSomethingWentWrong: this.keys.errorSomethingWentWrong,
            passwordButton: this.keys.passwordButton,
        })));

        this.updateDomSelectorsToCache();
        this.$cachedSelectors.form.on('submit', Odigeo._.bind(this.onSubmitPassword, this));
    },

    renderSuccessFeedback() {
        this.$cachedSelectors.setupPasswordContainer.append($(this.templates.successFeedback({
            title: this.keys.settingDoneTitle,
            description: this.keys.settingDoneDescription,
            button: this.keys.settingDoneButton,
        })));

        this.updateDomSelectorsToCache();
    },

    hideSetupPassword(flag) {
        const containers = [this.$cachedSelectors.setupPasswordTextContainer, this.$cachedSelectors.setupPasswordFormContainer];
        containers.forEach((container) => flag ? container.addClass('odf-hidden') : container.removeClass('odf-hidden'));
    },

    onPasswordChanged(event) {
        const $el = $(event.target);
        this.updateFieldState($el.data('name'));

        this.model.setPassword($el.val());

        this.validateConfirmedPassword(this.$el.find('.confirm_password'));
    },

    onConfirmPasswordChanged(event) {
        const $el = $(event.target);
        this.validateConfirmedPassword($el);
    },

    validateConfirmedPassword($el) {
        const $validationField = this.getValidationField($el);
        this.updateFieldState($el.data('name'));
        this.validatePasswords($el, $validationField);
    },

    validatePasswords($el, $validationField) {
        if (this.model.get('password') !== $el.val()) {
            const state = this.constants.invalidState;
            const stateClass = this.constants.invalidState;

            $validationField
                .addClass(stateClass)
                .attr('data-state', state);

            fieldUtils.showError($validationField);

            this.trackEvent('pwd_form_error', 'conf_pwd_match_inline_error_pag');
        }
    },

    validateFields() {
        const fieldSelectors = ['passwordInput', 'confirmPasswordInput'];
        const trackingAction = 'pwd_form_error';

        fieldSelectors.forEach((selector) => {
            const $field = this.$cachedSelectors[selector];
            const $validationField = this.getValidationField($field);
            const value = $field.val();
            const minLength = this.constants.minLength;
            const trackingTagPrefix = $field.hasClass('confirm_password') ? 'conf_' : '';

            if (!value.length) {
                $validationField
                    .addClass(this.constants.emptyState)
                    .attr('data-state', this.constants.emptyState);
                fieldUtils.showError($validationField);
                this.trackEvent(trackingAction, `create_${trackingTagPrefix}pwd_missing_submit_error_pag`);
            } else if (minLength > value.length > 0) {
                $validationField
                    .addClass(this.constants.invalidState)
                    .attr('data-state', this.constants.invalidState);
                fieldUtils.showError($validationField);
                this.trackEvent(trackingAction, `create_${trackingTagPrefix}pwd_requirements_submit_error_pag`);
            } else if (selector === 'confirmPassword') {
                this.validatePasswords($field, $validationField);
            }
        });
    },

    updateFieldState(fieldName) {
        const $el = this.$cachedSelectors.form.find(`[name="${fieldName}"]`);
        const $validationField = this.getValidationField($el);
        const fieldValue = $el.val();
        const state = Odigeo._.isEqual(fieldValue, this.constants.defaultState) ? this.constants.emptyState : this.constants.validState;
        const stateClass = state !== this.constants.validState ? this.constants.invalidState : state;

        $validationField
            .addClass(stateClass)
            .attr('data-state', state);

        return state;
    },

    getValidationField($el) {
        return $el.closest('.validation_field')
            .removeClass(this.constants.invalidState)
            .removeClass(this.constants.validState);
    },
    onInputFocus(event) {
        const $el = $(event.target);
        const isVisible = event.type === 'focusin';
        fieldUtils.showHidePlaceholder($el, isVisible);
        $el.closest(this.selectors.prismaInput).addClass('focused');
    },

    onBlurInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).removeClass('focused');
    },

    onValidateInput(e) {
        const $el = $(e.target);
        const $validationField = this.getValidationField($el);
        const val = $el.val();
        const minLength = this.constants.minLength;
        const trackingAction = 'pwd_form_error';
        const trackingTagPrefix = $el.hasClass('confirm_password') ? 'conf_' : '';

        this.onInputFocus(e);

        if (val.length && val.length < minLength) {
            $validationField
                .addClass(this.constants.invalidState)
                .attr('data-state', this.constants.invalidState);
            fieldUtils.showError($validationField);
            this.trackEvent(trackingAction, `${trackingTagPrefix}pwd_requirements_inline_error_pag`);
        } else if (!val.length && e.type === 'focusout') {
            $validationField
                .addClass(this.constants.emptyState)
                .attr('data-state', this.constants.emptyState);
            fieldUtils.showError($validationField);
            this.trackEvent(trackingAction, `${trackingTagPrefix}pwd_missing_inline_error_pag`);
        } else {
            $validationField
                .removeClass(this.constants.invalidState)
                .removeClass(this.constants.emptyState)
                .addClass(this.constants.validState)
                .attr('data-state', this.constants.validState);
            fieldUtils.setStateAndShowError($el, true, false);
        }
    },

    onValidateConfirmPasswordInput(element) {
        this.onValidateInput(element);
        const $el = $(element.target);
        const $validationField = this.getValidationField($el);
        this.validatePasswords($el, $validationField);
    },

    toggleLoadingSpinner(action) {
        const container = this.$cachedSelectors.loadingSpinnerContainer;
        const template = $(this.templates.loadingSpinner());

        action === 'show' && container.append(template);
        action === 'hide' && container.empty();
    },

    validateForm() {
        this.validateFields();

        return !this.$cachedSelectors.form
            .find('[data-state="empty"], [data-state="invalid"]').length;
    },

    onSubmitPassword(event) {
        event.preventDefault();
        const isFormValid = this.validateForm();

        if (isFormValid) {
            this.toggleLoadingSpinner('show');
            Odigeo.trigger(`${this.id}:submitUserRequest`, {
                action: 'changePasswordWithCode',
                data: {
                    newPassword: this.model.getPassword(),
                    hashCode: this.model.getHashCode(),
                },
            });
        } else {
            this.trackEvent('pwd_form_error', 'create_pwd_FE_error_pag');
        }
    },

    onTapSearchWithPrime(event) {
        event.preventDefault();
        this.trackEvent('pwd_form_success', 'searche_prime_pag');
        Odigeo.Utils.goToApplicationHome();
    },

    passwordOk() {
        this.toggleLoadingSpinner('hide');
        this.hideSetupPassword(true);
        this.renderSuccessFeedback();
        this.trackEvent('pwd_form', 'create_pwd_success_pag');
    },

    passwordError() {
        this.toggleLoadingSpinner('hide');
        const $el = this.$el.find('.something_wrong');
        $el.removeClass('odf-hidden');
        this.trackEvent('pwd_form_error', 'create_pwd_server_submit_error_pag');
    },

    trackEvent(action, tag) {
        Odigeo.trigger(`${this.id}:track`, {action, tag});
    },
})));
